import type { Crm } from '../../../../domain/crm';
import { UserRole } from '../../../../domain/user';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

const userRoleTrackingName: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'admin',
  [UserRole.CHAMPION]: 'champion',
  [UserRole.USER]: 'user',
};

export const useCrmActionsTracking = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleCrmLinkTrack = (crm: Crm) =>
    dispatchTrackEventWithLocation('contacts export', 'see contact in crm', `see record in ${crm}`);

  const handleEnableExportTrack = (action: string, userRole: UserRole) =>
    dispatchTrackEventWithLocation('enable export', action, userRoleTrackingName[userRole] || '');

  return {
    handleCrmLinkTrack,
    handleEnableExportTrack,
  };
};
